/** Defer a single click so a double click never also moves the object. */
export function decorClicks(move:(id:string)=>void,style:(id:string)=>void,delay=350){
 let pending:{id:string;timer:ReturnType<typeof setTimeout>}|undefined;
 return {
  click(id:string,touch=false){
   if(pending?.id===id){clearTimeout(pending.timer);pending=undefined;style(id);return;}
   if(pending)clearTimeout(pending.timer);
   pending={id,timer:setTimeout(()=>{pending=undefined;move(id);},touch?550:delay)};
  },
  cancel(){if(pending)clearTimeout(pending.timer);pending=undefined;},
 };
}
